import {Box, Text} from 'platform/foundation';

import {TestIdProps} from 'shared/web';

export function CustomerSatisfactionCommentBubble(props: {comment: string} & TestIdProps) {
  return (
    <Box
      data-testid={props['data-testid']}
      backgroundColor="palettes.neutral.20.100"
      paddingVertical={2}
      paddingHorizontal={3}
      borderTopRightRadius="medium"
      borderBottomLeftRadius="medium"
      borderBottomRightRadius="medium"
    >
      <Text size="small" preWrap>
        {props.comment}
      </Text>
    </Box>
  );
}
